import React from 'react';
import { LookerStudioIframe } from 'components/LookerStudioIframe';
import { getLookerReportDownloadUrl } from 'utils/report';
import { Button, Link, Stack } from '@mui/material';
import { OpenInNewOutlined } from '@mui/icons-material';
import { ReactComponent as DownloadIcon } from 'assets/icons/download_icon.svg';
import { CampaignStatus } from 'types';

export const OverviewReport = ({
  embedded,
  link,
  status,
  id,
}: {
  embedded: string;
  link: string;
  status: CampaignStatus;
  id: number;
}) => {
  return (
    <>
      <Stack direction="row" spacing={2} mb={8} justifyContent="end">
        <Button
          sx={{ marginLeft: '8px', height: 'auto' }}
          component={Link}
          href={link}
          target="_blank"
          startIcon={<OpenInNewOutlined />}
        >
          In eigenem tab öffnen
        </Button>
        {link && [CampaignStatus.active, CampaignStatus.over].includes(status) ? (
          <Button
            sx={{ marginLeft: '8px', height: 'auto' }}
            component={Link}
            href={getLookerReportDownloadUrl(id)}
            target="_blank"
            startIcon={<DownloadIcon />}
          >
            als PDF herunterladen
          </Button>
        ) : null}
      </Stack>
      <LookerStudioIframe embeddedLookerUrl={embedded} />
    </>
  );
};
